import { AddCustomerAddressInput, EditCustomerAddressInput } from "../customer-address";
import { AddCustomerEmployeeInput, EditCustomerEmployeeInput } from "../customer-employee";

export class EditCustomerInput {
    public code: string = '';
    public name: string = '';
    public taxNumber: string = '';
    public taxAdministration: string = '';
    public logoFile = '';
    public logoFileName = '';
    public addCustomerProjects: Array<number> = [];
    public addCustomerCargoIntegrations: Array<number> = [];
    public addCustomerERPs: Array<number> = [];
    public addCustomerModules: Array<number> = [];
    public addCustomerVirtualPoses: Array<number> = [];
    public addEmployees: Array<AddCustomerEmployeeInput> = [];
    public editEmployees: Array<EditCustomerEmployeeInput> = [];
    public deleteEmployees: Array<number> = [];
    public addCustomerAddresses: Array<AddCustomerAddressInput> = [];
    public editCustomerAddresses: Array<EditCustomerAddressInput> = [];
    public deleteCustomerAddresses: Array<number> = [];
}
